<section class="sport-tree" id="sport-tree">
    <div class="section-title" *ngIf="!selectedSport;">Sport</div>
    <ul class="list">
      <li>
        <div *ngIf="favoriteCompetitions.length > 0 && favoriteCompetitionsHaveOnlineEvents" class="sport-info" [class.open]="favoriteLeaguesIsExpanded"
          (click)="favoriteLeaguesIsExpanded = !favoriteLeaguesIsExpanded">
          <div class="name-wrap">
            <!-- <div class="icon-wrap"> -->
              <!-- <app-svg-icon iconId="star"></app-svg-icon> -->
              <i class="sporticon icon-sm sporticon-star m-r"></i>
            <!-- </div> -->
            <span class="name">{{myLeaguesTitle}}</span>
          </div>
        </div>
        <ul class="sub-list region-list" *ngIf="favoriteLeaguesIsExpanded && favoriteCompetitions.length > 0">
          <ng-container *ngFor="let competition of favoriteCompetitions">
            <li [class.selected]="competition.isSelected" *ngIf="competition.isShown"
              (click)="selectCompetitionFromFavorites(competition)">
              <span class="icon" (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                <!-- <app-svg-icon iconId="{{competition.isInFavorites ? 'star' : 'star-empty'}}"></app-svg-icon> -->
                <app-svg-icon iconId="star"></app-svg-icon>
              </span>
              <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
              <span class="events-name">{{competition.eventsCount}}</span>
            </li>
          </ng-container>
        </ul>
      </li>

      <ng-container *ngFor="let sport of sports;">
        <li *ngIf="sport.eventsCount > 0">
        <div class="sport-info" [class.open]="sport.isSelected" (click)="selectSport(sport); $event.stopPropagation();">

          <div class="name-wrap">
            <!-- <div class="icon-wrap"> -->
              <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -1"><sub>{{dynamicTranslations.specialOfferEventsShorcutEventOfDay}}</sub></i>
              <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -2"><sub>{{dynamicTranslations.specialOfferEventsShorcutSuperBet}}</sub></i>
              <i class="sporticon icon-sm m-r sporticon-all" *ngIf="sport.id == -3"><sub>{{dynamicTranslations.specialOfferEventsShorcutOutrights}}</sub></i>
              <!-- <span class="text-icon eod" *ngIf="sport.id == -1">EoD</span>
              <span class="text-icon" *ngIf="sport.id == -2">SB</span> -->

              <!-- <app-svg-icon *ngIf="sport.id != -1 && sport.id != -2" iconId="{{sport.id}}"></app-svg-icon> -->
              <i class="sporticon icon-sm m-r s-icon-{{getSportName(sport.id)}}" *ngIf="sport.id != -1 && sport.id != -2"></i>
            <!-- </div> -->
            <span class="name">{{sport.name}}</span>
          </div>
          <div class="events-number">{{sport.eventsCount}}</div>
        </div>

        <ul class="sub-list region-list" *ngIf="sport.showRegions && sport.regions.length > 0">
          <ng-container *ngFor="let region of sport.regions;">
            <ng-container *ngFor="let competition of region.competitions;">
              <li *ngIf="competition.eventsCount>0" (click)="selectCompetition(competition, region, sport)" [class.selected]="competition.isSelected" >
              <span class="icon" (click)="addRemoveCompetitionToFavorites(competition); $event.stopPropagation();">
                <!-- <app-svg-icon iconId="{{competition.isInFavorites ? 'star' : 'star-empty'}}"></app-svg-icon> -->
              </span>
              <span class="region-name">{{competition.regionName}} {{competition.name}}</span>
              <span class="events-name">{{competition.eventsCount}}</span>
              </li>
            </ng-container >
          </ng-container>
        </ul>
        </li>
     </ng-container>

    </ul>

    <!-- <div class="show-more">Show more</div> -->
</section>
